module.exports = __webpack_public_path__ + "img/钱包.81c7ba2c.png";